import { renderBehavioralData } from "./render-behavioral";
import { renderPrescribeData } from "./render-prescribe";
import { renderSessionMetaData } from "./render-session-meta";

export const noteV1Display = (note, patientName) => {
  return (
    <>
      {renderSessionMetaData(note.session_date, note, patientName)}

      {note.provider_type &&
        note.provider_type.startsWith("BEHAVIORAL") &&
        renderBehavioralData(note)}
      {note.provider_type && note.provider_type === "PRESCRIBE" && renderPrescribeData(note)}
    </>
  );
};
